import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Image } from 'lucide-react';

const GraphicalAbstract = ({ articleId }) => (
  <Link to={`/graphical-abstract/${articleId}`}>
    <Button variant="outline" size="sm" className="border-indigo-500 text-indigo-600 hover:bg-indigo-50 dark:hover:bg-indigo-950/30" data-testid="graphical-abstract-btn">
      <Image className="mr-1.5 h-4 w-4" />
      Graphical Abstract
    </Button>
  </Link>
);

export default GraphicalAbstract;
